import { getAuthToken } from "../../utils/basis_util";

//利用ログ登録
export const usageLog = async (
  userId: string,
  displayPage: string,
  displayDateTime: string,
  additionalInfo?: string
) => {
  try {
    console.log("register usageLog API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    console.log("displayPage: ", displayPage);
    console.log("displayDateTime: ", displayDateTime);
    if (additionalInfo) {
      console.log("additionalInfo: ", additionalInfo);
    }

    // トークンを取得
    const token = await getAuthToken();

    let params;

    if (additionalInfo) {
      params = {
        userId: userId,
        displayPage: displayPage,
        displayDateTime: displayDateTime,
        additionalInfo: additionalInfo,
      };
    } else {
      params = {
        userId: userId,
        displayPage: displayPage,
        displayDateTime: displayDateTime,
      };
    }
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/usageLog/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      //credentials: "include",
      body: JSON.stringify(params),
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("result" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("register usageLog API end.");
    return resJson;
  } catch (err) {
    console.log("[registerUsageLog]err: ", err);
    throw err;
  }
};

//未回答数取得
export const getUnanswered = async (userId: string) => {
  try {
    console.log("get unanswered API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);

    // トークンを取得
    const token = await getAuthToken();

    const params = { userId: userId };
    const query_params = new URLSearchParams(params);
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/unanswered?" + query_params, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("unansweredNum" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("get unanswered API end.");
    return resJson;
  } catch (err) {
    console.log("[getUnanswered]err: ", err);
    throw err;
  }
};

//案件名確認
export const checkSubjectName = async (userId: string, subjectName: string) => {
  try {
    console.log("check subject name API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    console.log("subjectName: ", subjectName);

    // トークンを取得
    const token = await getAuthToken();

    const params = {
      userId: userId,
      subjectName: subjectName,
    };

    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(
      apiEndpoint + "/searchHistoryInfo/checkSubjectName",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        //credentials: "include",
        body: JSON.stringify(params),
      }
    );

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("result" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("check subject name API end.");
    return resJson;
  } catch (err) {
    console.log("[checkSubjectName]err: ", err);
    throw err;
  }
};

//署名付きURL取得
export const getPresignedUrl = async (
  userId: string,
  type: string,
  expire?: string,
  language?: string
) => {
  try {
    console.log("get presigned url API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    console.log("type: ", type);
    if (expire) console.log("expire", expire);

    // トークンを取得
    const token = await getAuthToken();

    let params;
    if (expire) {
      params = {
        userId: userId,
        type: type,
        expire: expire,
        language: language ?? "",
      };
    } else {
      params = { userId: userId, type: type, language: language ?? "" };
    }
    const query_params = new URLSearchParams(params);
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/presignedUrl?" + query_params, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("presignedUrl" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("get presigned url API end.");
    return resJson;
  } catch (err) {
    console.log("[getPresignedUrl]err: ", err);
    throw err;
  }
};

//フィードバック情報取得
export const getFbInfo = async (userId: string, searchHistoryId: string) => {
  try {
    console.log("get feedback API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    console.log("searchHistoryId: ", searchHistoryId);

    // トークンを取得
    const token = await getAuthToken();

    const params = { userId: userId, searchHistoryId: searchHistoryId };
    const query_params = new URLSearchParams(params);
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(
      apiEndpoint + "/searchHistoryInfo/getFbInfo?" + query_params,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !(
        "resolved" in resJson &&
        "resolvedFactor" in resJson &&
        "notApplicableFlag" in resJson
      ) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("get feedback API end.");
    return resJson;
  } catch (err) {
    console.log("[getFbInfo]err: ", err);
    throw err;
  }
};
//フィードバック情報更新
export const updateFbInfo = async (
  userId: string,
  searchHistoryId: string,
  resolved: string,
  resolvedFactor: string[],
  notApplicableFlag: string,
  status: string
) => {
  try {
    console.log("update feedback API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    console.log("searchHistoryId: ", searchHistoryId);
    console.log("resolved: ", resolved);
    console.log("resolvedFactor: ", resolvedFactor);
    console.log("notApplicableFlag: ", notApplicableFlag);
    console.log("status: ", status);

    // トークンを取得
    const token = await getAuthToken();

    const params = {
      userId: userId,
      searchHistoryId: searchHistoryId,
      resolved: resolved,
      resolvedFactor: resolvedFactor,
      notApplicableFlag: notApplicableFlag,
      status: status,
    };

    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/searchHistoryInfo/updateFbInfo", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      //credentials: "include",
      body: JSON.stringify(params),
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("result" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("update feedback API end.");
    return resJson;
  } catch (err) {
    console.log("[updateFbInfo]err: ", err);
    throw err;
  }
};

//検索履歴情報登録
export const registerSearchHistoryInfo = async (
  userId: string,
  subjectName: string,
  model: string,
  phenomenon: string[],
  inferenceFactor: string,
  language: string,
  searchDateTime: string,
  machineNumber?: string
) => {
  console.log("register search hisotry API start.");
  console.log("[Parameters]");
  console.log("userId: ", userId);
  console.log("subjectName: ", subjectName);
  console.log("model: ", model);
  if (machineNumber) console.log("machineNumber: ", machineNumber);
  console.log("phenomenon: ", phenomenon);
  console.log("inferenceFactors: ", inferenceFactor);
  console.log("language: ", language);
  console.log("searchDateTime: ", searchDateTime);
  try {
    // トークンを取得
    const token = await getAuthToken();

    let params;

    if (machineNumber) {
      params = {
        userId: userId,
        subjectName: subjectName,
        model: model,
        phenomenon: phenomenon,
        inferenceFactor: inferenceFactor,
        language: language,
        searchDateTime: searchDateTime,
        machineNumber: machineNumber,
      };
    } else {
      params = {
        userId: userId,
        subjectName: subjectName,
        model: model,
        phenomenon: phenomenon,
        inferenceFactor: inferenceFactor,
        language: language,
        searchDateTime: searchDateTime,
      };
    }

    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/searchHistoryInfo/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      //credentials: "include",
      body: JSON.stringify(params),
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("searchHistoryId" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("register search hisotry API end.");

    return resJson;
  } catch (err) {
    console.log("[registerSearchHistoryInfo]err: ", err);
    throw err;
  }
};

//推定要因項目取得
export const getInferenceFactor = async (
  model: string,
  phenomenons: string[],
  modelType: string,
  language?: string
) => {
  try {
    console.log("get inference factor API start.");
    console.log("[Parameters]");
    console.log("model: ", model);
    console.log("phenomenons: ", phenomenons);
    console.log("modelType: ", modelType);
    if (language) console.log("language: ", language);

    // トークンを取得
    const token = await getAuthToken();

    let params;

    if (language) {
      params = {
        model: model,
        phenomenons: phenomenons,
        language: language,
        modelType: modelType,
      };
    } else {
      params = {
        model: model,
        phenomenons: phenomenons,
        modelType: modelType,
      };
    }
    const apiEndpoint = process.env.REACT_APP_AWS_INFERENCE_FACTOR_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/inferenceFactor", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      //credentials: "include",
      body: JSON.stringify(params),
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("inferenceFactor" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("get inference factor API end.");
    return resJson;
  } catch (err) {
    console.log("[getInferenceFactor]err: ", err);
    throw err;
  }
};

// 型式取得
export const getEngineModel = async (userId: string, language?: string) => {
  try {
    console.group("get engine model API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    if (language) console.log("language: ", language);

    // トークンを取得
    const token = await getAuthToken();

    let params;

    if (language) {
      params = {
        userId: userId,
        language: language,
      };
    } else {
      params = {
        userId: userId,
      };
    }
    const query_params = new URLSearchParams(params);
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/model?" + query_params, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("model" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("get engine model API end.");
    console.groupEnd();
    return resJson;
  } catch (err) {
    console.log("[getEngineModel]err: ", err);
    console.groupEnd();
    throw err;
  }
};

// 現象取得
export const getPhenomenon = async (userId: string, language?: string) => {
  try {
    console.group("get phenomenon API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    if (language) console.log("language: ", language);

    // トークンを取得
    const token = await getAuthToken();

    let params;

    if (language) {
      params = {
        userId: userId,
        language: language,
      };
    } else {
      params = {
        userId: userId,
      };
    }
    const query_params = new URLSearchParams(params);
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/phenomenon?" + query_params, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("phenomenon" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("get phenomenon API end.");
    console.groupEnd();
    return resJson;
  } catch (err) {
    console.log("[getEngineModel]err: ", err);
    console.groupEnd();
    throw err;
  }
};

//検索履歴一覧取得
export const getSearchHistoryList = async (
  userId: string,
  pageNum: number,
  numPerPage: number,
  sortOrder: string,
  filterItem: string,
  configValue: string
) => {
  try {
    console.group("get search history list API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    console.log("pageNum: ", pageNum);
    console.log("numPerPage: ", numPerPage);
    console.log("sortOrder: ", sortOrder);
    console.log("filterItem: ", filterItem);
    console.log("configValue: ", configValue);

    // トークンを取得
    const token = await getAuthToken();

    const params = {
      userId: userId,
      pageNum: String(pageNum),
      numPerPage: String(numPerPage),
      sortOrder: sortOrder,
      filterItem: filterItem,
      configValue: configValue,
    };
    const query_params = new URLSearchParams(params);
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(
      apiEndpoint + "/searchHistoryInfo/list?" + query_params,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !(
        "searchHistoryInfo" in resJson &&
        "totalPageNum" in resJson &&
        "pageNum" in resJson
      ) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("get search history list API end.");
    console.groupEnd();
    return resJson;
  } catch (err) {
    console.log("[getSearchHistoryList]err: ", err);
    console.groupEnd();
    throw err;
  }
};

//検索履歴詳細取得
export const getSearchHistoryDetail = async (
  userId: string,
  searchHistoryId: string
) => {
  try {
    console.group("get search history detail API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    console.log("searchHistoryId: ", searchHistoryId);

    // トークンを取得
    const token = await getAuthToken();

    const params = {
      userId: userId,
      searchHistoryId: searchHistoryId,
    };
    const query_params = new URLSearchParams(params);
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(
      apiEndpoint + "/searchHistoryInfo/detail?" + query_params,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = JSON.parse(await res.json());
    console.log("resJson: ", resJson);
    if (
      !("inferenceFactor" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("get search history detail API end.");
    console.groupEnd();
    return resJson;
  } catch (err) {
    console.log("[getSearchHistoryDetail]err: ", err);
    console.groupEnd();
    throw err;
  }
};

//検索履歴情報削除
export const deleteSearchHistory = async (
  userId: string,
  searchHistoryId: string
) => {
  try {
    console.group("delete search history API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    console.log("searchHistoryId: ", searchHistoryId);

    // トークンを取得
    const token = await getAuthToken();

    const params = {
      userId: userId,
      searchHistoryId: searchHistoryId,
    };
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/searchHistoryInfo/delete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      //credentials: "include",
      body: JSON.stringify(params),
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("result" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("delete search history API end.");
    console.groupEnd();
    return resJson;
  } catch (err) {
    console.log("[deleteSearchHistory]err: ", err);
    console.groupEnd();
    throw err;
  }
};

//お気に入り情報取得
export const getFavoriteInfo = async (userId: string, dmcInfo: string) => {
  try {
    console.group("get favorite info API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    console.log("dmcInfo: ", dmcInfo);

    // トークンを取得
    const token = await getAuthToken();

    const params = {
      userId: userId,
      dmcInfo: dmcInfo,
    };
    const query_params = new URLSearchParams(params);
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/favorite?" + query_params, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !(
        "id" in resJson &&
        "model" in resJson &&
        "title" in resJson &&
        "displayDateTime" in resJson
      ) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("get favorite info API end.");
    console.groupEnd();
    return resJson;
  } catch (err) {
    console.log("[getFavoriteInfo]err: ", err);
    console.groupEnd();
    throw err;
  }
};

//お気に入り情報一覧取得
export const getFavoriteInfoList = async (
  userId: string,
  pageNum: number,
  numPerPage: number,
  sortOrder: string
) => {
  try {
    console.group("get favorite info list API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    console.log("pageNum: ", pageNum);
    console.log("numPerPage: ", numPerPage);
    console.log("sortOrder: ", sortOrder);

    // トークンを取得
    const token = await getAuthToken();

    const params = {
      userId: userId,
      pageNum: String(pageNum),
      numPerPage: String(numPerPage),
      sortOrder: sortOrder,
    };
    const query_params = new URLSearchParams(params);
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/favorite/list?" + query_params, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !(
        "favoriteInfo" in resJson &&
        "totalPageNum" in resJson &&
        "pageNum" in resJson
      ) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("get favorite info list API end.");
    console.groupEnd();
    return resJson;
  } catch (err) {
    console.log("[getFavoriteInfoList]err: ", err);
    console.groupEnd();
    throw err;
  }
};

//お気に入り閲覧日時更新
export const updateFavoriteDisplayDateTime = async (
  userId: string,
  id: number
) => {
  try {
    console.group("update favorite display date time API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    console.log("id: ", id);

    // トークンを取得
    const token = await getAuthToken();

    const params = {
      userId: userId,
      id: id,
    };
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/favorite/updateDisplayDateTime", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      //credentials: "include",
      body: JSON.stringify(params),
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("result" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("update favorite display date time API end.");
    console.groupEnd();
    return resJson;
  } catch (err) {
    console.log("[updateFavoriteDisplayDateTime]err: ", err);
    console.groupEnd();
    throw err;
  }
};

//お気に入りタイトル更新
export const updateFavoriteTitle = async (
  userId: string,
  id: number,
  model: string,
  title: string
) => {
  try {
    console.group("update favorite title API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    console.log("id: ", id);
    console.log("model: ", model);
    console.log("title: ", title);

    // トークンを取得
    const token = await getAuthToken();

    const params = {
      userId: userId,
      id: id,
      model: model,
      title: title,
    };
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/favorite/updateTitle", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      //credentials: "include",
      body: JSON.stringify(params),
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("result" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("update favorite title API end.");
    console.groupEnd();
    return resJson;
  } catch (err) {
    console.log("[updateFavoriteTitle]err: ", err);
    console.groupEnd();
    throw err;
  }
};

//お気に入り情報登録
export const registerFavoriteInfo = async (
  userId: string,
  dmcInfo: string,
  model: string,
  title: string
) => {
  try {
    console.group("register favorite info API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    console.log("dmcInfo: ", dmcInfo);
    console.log("model: ", model);
    console.log("title: ", title);

    // トークンを取得
    const token = await getAuthToken();

    const params = {
      userId: userId,
      dmcInfo: dmcInfo,
      model: model,
      title: title,
    };
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/favorite/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      //credentials: "include",
      body: JSON.stringify(params),
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("id" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("register favorite info API end.");
    console.groupEnd();
    return resJson;
  } catch (err) {
    console.log("[registerFavoriteInfo]err: ", err);
    console.groupEnd();
    throw err;
  }
};

//お気に入り情報削除
export const deleteFavoriteInfo = async (userId: string, id: number) => {
  try {
    console.group("delete favorite info API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    console.log("id: ", id);

    // トークンを取得
    const token = await getAuthToken();

    const params = {
      userId: userId,
      id: id,
    };
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/favorite/delete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      //credentials: "include",
      body: JSON.stringify(params),
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("result" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("delete favorite info API end.");
    console.groupEnd();
    return resJson;
  } catch (err) {
    console.log("[deleteFavoriteInfo]err: ", err);
    console.groupEnd();
    throw err;
  }
};

//免責事項情報取得
export const getDisclaimerInfo = async (userId: string, language: string) => {
  try {
    console.group("get disclaimer info API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    console.log("language: ", language);

    // トークンを取得
    const token = await getAuthToken();

    const params = {
      userId: userId,
      language: language,
    };
    const query_params = new URLSearchParams(params);
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/disclaimer?" + query_params, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("disclaimer" in resJson && "version" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("get disclaimer info API end.");
    console.groupEnd();
    return resJson;
  } catch (err) {
    console.log("[getDisclaimerInfo]err: ", err);
    console.groupEnd();
    throw err;
  }
};

//免責事項同意状態取得
export const getDisclaimerAgreeStatus = async (userId: string) => {
  try {
    console.group("get disclaimer agree status API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);

    // トークンを取得
    const token = await getAuthToken();

    const params = {
      userId: userId,
    };
    const query_params = new URLSearchParams(params);
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(
      apiEndpoint + "/disclaimer/agreeStatus?" + query_params,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("agreeStatus" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("get disclaimer agree status API end.");
    console.groupEnd();
    return resJson;
  } catch (err) {
    console.log("[getDisclaimerAgreeStatus]err: ", err);
    console.groupEnd();
    throw err;
  }
};

//免責事項同意状態更新
export const updateDisclaimerAgreeStatus = async (
  userId: string,
  version: string
) => {
  try {
    console.group("update disclaimer agree status API start.");
    console.log("[Parameters]");
    console.log("userId: ", userId);
    console.log("version: ", version);

    // トークンを取得
    const token = await getAuthToken();

    const params = {
      userId: userId,
      version: version,
    };
    const apiEndpoint = process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT;
    if (!apiEndpoint) {
      //環境変数が正しく設定されてなければエラー
      throw new Error("API endpoint is not configured.");
    }
    const res = await fetch(apiEndpoint + "/disclaimer/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      //credentials: "include",
      body: JSON.stringify(params),
    });

    if (res.status === 401) {
      // トークンが無効
      console.log("Invalid token");
      throw new Error("Invalid token");
    }

    const resJson = await res.json();
    console.log("resJson: ", resJson);
    if (
      !("result" in resJson) &&
      !("errorCode" in resJson && "errorMessage" in resJson)
    ) {
      //APIが想定してないメッセージが返ってきた
      throw new Error("Unknown Error Message Type is received.");
    }
    console.log("update disclaimer agree status API end.");
    console.groupEnd();
    return resJson;
  } catch (err) {
    console.log("[updateDisclaimerAgreeStatus]err: ", err);
    console.groupEnd();
    throw err;
  }
};
